<script>
import dialog2Mixin from "../mixins/dialog2";
import { authComputed } from "@store/helpers";

export default {
  components: {
    FormLogin: () => import("@components/Form/FormLogin"),
  },
  mixins: [dialog2Mixin],
  data() {
    return {
      submitData: {
        phoneCode: '+886',
        phoneNumber: '0912345678',
        verificationCode: '',
      },
      fromStep: 1,
      coldDownGetcode: 0,

      callbackLogin: () => {},
      afterLoginRouteName: 'member',
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    onSubmitCallback({ submitData } = {}) {
      this.dialog2MixinVisible = false;
      this.callbackLogin();
    }
  }
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogLogin } isStyleLogin isStep${fromStep}`"
    width="378px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="$Dialog2MixinOnDestroy"
  >
    <FormLogin
      :from-step.sync="fromStep"
      :after-login-route-name="afterLoginRouteName"
      @submitCallback="onSubmitCallback"
      @cancel="dialog2MixinVisible = false"
    />
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogLogin {
  :global {
    .dialogLogin {
      @include unstyled;
    }
  }
}
</style>
